import styled from "styled-components";
import colors from "@styling/colors";
import { fontSizes } from "@styling/fonts";
import { spacing } from "@styling/sizing";

export const Title = styled.h1`
  margin: 0;
  font-size: ${fontSizes.xlarge}px;
  font-weight: 600;
  color: ${colors.text};
`;

export const PageHeading = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.x1}px;
`;

